module.exports = __webpack_public_path__ + "static/media/Value.7318a384.png";